import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	successTitle: {
		id: 'dashboard-edit.services.success-title',
		defaultMessage: 'Gadget has been removed',
		description: 'Success title on gadget delete',
	},
	successDescription: {
		id: 'dashboard-edit.services.success-description',
		defaultMessage: 'You\'ve successfully removed the "{name}" gadget.',
		description: 'Success description on gadget delete',
	},
	failureTitle: {
		id: 'dashboard-edit.services.failure-title',
		defaultMessage: "We couldn't delete the gadget",
		description: 'Failure title when gadget delete was failed',
	},
	failureDescription: {
		id: 'dashboard-edit.services.failure-description',
		defaultMessage: 'Give it a couple of minutes, then try again.',
		description: 'Failure description when gadget delete was failed',
	},
});
